import React from "react";
import { Link } from "react-router-dom";

export function Logo({ size = "md", variant = "dark" }) {
  const text = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl",
    xl: "text-4xl",
  }[size];
  const color = variant === "light" ? "text-white" : "text-[#1A1C1E]";
  return (
    <Link to="/" className={`font-display font-semibold tracking-tight ${text} ${color} inline-flex items-center gap-2`} data-testid="brand-logo">
      <span className="inline-block h-2 w-2 rounded-full bg-[#C86B53]" />
      NEIV
    </Link>
  );
}
